import React, { createContext, useContext, ReactNode } from 'react';
import { useConversationsStore } from '@/stores';
import { Conversation } from '@/types';
interface ConversationsContextType {
  currentConversationId: string | undefined;
  setCurrentConversationId: (id: string | undefined) => void;
  expandedProjectIds: Set<string>;
  setExpandedProjectIds: React.Dispatch<React.SetStateAction<Set<string>>>;
  sidebarProjectConversationsCache: Record<string, Conversation[]>;
  setSidebarProjectConversationsCache: React.Dispatch<
    React.SetStateAction<Record<string, Conversation[]>>
  >;
  projectExpand: (projectId: string) => void;
}
const ConversationsContext = createContext<
  ConversationsContextType | undefined
>(undefined);
export function ConversationsProvider({ children }: { children: ReactNode }) {
  const {
    currentConversationId,
    setCurrentConversationId,
    expandedProjectIds,
    setExpandedProjectIds,
    sidebarProjectConversationsCache,
    setSidebarProjectConversationsCache,
    projectExpand,
  } = useConversationsStore();
  return (
    <ConversationsContext.Provider
      value={{
        currentConversationId,
        setCurrentConversationId,
        expandedProjectIds,
        setExpandedProjectIds,
        sidebarProjectConversationsCache,
        setSidebarProjectConversationsCache,
        projectExpand,
      }}
    >
      {children}
    </ConversationsContext.Provider>
  );
}
// eslint-disable-next-line react-refresh/only-export-components
export function useConversationsContext() {
  const context = useContext(ConversationsContext);
  if (context === undefined) {
    throw new Error(
      'useConversationsContext must be used within a ConversationsProvider'
    );
  }
  return context;
}
